<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  data: () => {
    const beginTime = 0
    const differTime = 0
    return {
      beginTime,
      differTime
    }
  },
  methods: {
    // 关闭事件
    handleCloseFn(event) {
      // 监听关闭
      // console.log('unload')
      this.differTime = new Date().getTime() - this.beginTime
      // console.log(this.differTime)
      // debugger;
      if (this.differTime <= 5) {
        console.log('浏览器关闭')
        localStorage.removeItem('isRefresh')
      } else {
        console.log('浏览器刷新')
        localStorage.setItem('isRefresh', 'true')
      }

      // event = event || window.event;
      // if (event) {
      //   event.returnValue = "关闭提示";
      // }
      // return "关闭提示";
    },
    // 刷新事件
    handleRefreshFn(event) {
      this.beginTime = new Date().getTime()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.handleRefreshFn)

    window.addEventListener('unload', this.handleCloseFn)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handleRefreshFn)

    window.removeEventListener('unload', this.handleCloseFn)
  }
}
</script>

<style style="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #3d4954;
}
</style>
